import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pad-s mleft-06"
}
const _hoisted_2 = {
  key: 1,
  class: "pad-s mleft-06"
}
const _hoisted_3 = {
  key: 0,
  class: "pad-s mleft-06"
}
const _hoisted_4 = {
  key: 3,
  class: "pad-s mleft-06"
}

import loadingSpinner from "@/views/loadingSpinner.vue";

import { ref, watch, onMounted } from 'vue'
import { useDebounceFn } from '@vueuse/core'
import { apiDateString } from "@/api/apicommon"
import { AccountingApi, InvoiceSearchItemResponse, FinancialGroupLightResponse } from '@/apiGenerate/medserver'
import { medServerApiConfig } from '@/config/medserver-api.config'
import { useI18n } from 'vue-i18n'
import PersonService from "@/services/PersonService";

type InvoiceSearchItemWithGroup = (InvoiceSearchItemResponse & { financialGroup: FinancialGroupLightResponse });


export default /*@__PURE__*/_defineComponent({
  __name: 'searchInvoice',
  emits: ["invoiceClicked"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const accountingApi = new AccountingApi(medServerApiConfig)

const emits = __emit;

function clickOnInvoice(invoice: InvoiceSearchItemWithGroup) {
  emits('invoiceClicked', invoice)
}

const focusRef = ref()
const searchContent = ref('')
const searchResults = ref<(InvoiceSearchItemWithGroup)[]>([])
const hasMore = ref(false)
const isLoading = ref(false)

const performSearch = async (query: string) => {
  try {
    isLoading.value = true
    const response = await accountingApi.searchInvoices({ q: query })
    searchResults.value = response.groups?.flatMap(group =>
      group.invoices.map(inv => ({ ...inv, financialGroup: group.financialGroup }))
    ) || []
    hasMore.value = response.hasMore
  } catch (error) {
    console.error('Search error:', error)
    searchResults.value = []
  } finally {
    isLoading.value = false
  }
}

const debouncedSearch = useDebounceFn(performSearch, 500)

watch(searchContent, (newValue) => {
  if (newValue.length < 4) {
    searchResults.value = []
    hasMore.value = false
    isLoading.value = false
  } else {
    debouncedSearch(newValue)
  }
})

onMounted(() => {
  focusRef.value.innerRef.focus()
})

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!

  return (_openBlock(), _createBlock(_component_inputComboBox2, {
    ref_key: "focusRef",
    ref: focusRef,
    modelValue: searchContent.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchContent).value = $event)),
    style: {"width":"28rem"}
  }, {
    dropd: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(loadingSpinner, {
              logo: false,
              style: 'w-3'
            })
          ]))
        : (searchContent.value.length < 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('accounting.search.minCharacters'),
                styles: "main-l"
              }, null, 8, ["txt"])
            ]))
          : (searchResults.value.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mtop-04" }, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (invoice) => {
                  return (_openBlock(), _createBlock(_component_list_group, {
                    key: invoice.id,
                    class: "gap-04",
                    styles: "pad-s",
                    onClick: ($event: any) => (clickOnInvoice(invoice))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_item, {
                        icon: "file",
                        styles: "main-m",
                        class: "mleft-06",
                        style: {"margin-top":"-0.2rem"}
                      }),
                      _createVNode(_component_text_item, {
                        txt: invoice.invoiceReference,
                        styles: "main-m"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_text_item, {
                        txt: _unref(PersonService).formatName(invoice.pwrCounterParty.lastName, invoice.pwrCounterParty.firstName),
                        class: "name-max-w"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_text_item, {
                        txt: _unref(apiDateString)(invoice.invoiceDateTime),
                        styles: "main-l",
                        class: "mleft-04"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_text_item, {
                        txt: invoice.amount,
                        styles: "main-l"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_text_item, {
                        txt: "€",
                        styles: "main-l"
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128)),
                (hasMore.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('accounting.search.hasMore'),
                        styles: "main-l"
                      }, null, 8, ["txt"])
                    ]))
                  : _createCommentVNode("", true),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mtop-04" }, null, -1))
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('accounting.noData'),
                  styles: "main-l"
                }, null, 8, ["txt"])
              ]))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})